import { actionTypes } from '../constants/actionTypes';

const initialInfoMessage = {
  message: '',
  isSuccess: false
};

export const displayLoader = (state = false, action) => {
  switch (action.type) {
    case actionTypes.DISPLAY_LOADER:
      return action.payload;
  }

  return state;
};

export const displayMessage = (state = false, action) => {
  switch (action.type) {
    case actionTypes.DISPLAY_MESSAGE:
      return action.payload;
  }

  return state;
};

export const customerLogoUrl = (state = '', action) => {
  switch (action.type) {
    case actionTypes.CUSTOMER_LOGO_URL:
      return action.payload;
  }
  return state;
};

export const customerId = (state = '', action) => {
  switch (action.type) {
    case actionTypes.CUSTOMER_ID:
      return action.payload;
  }
  
  return state;
};

export const customerDateFormat = (state = '', action) => {
  switch (action.type) {
    case actionTypes.CUSTOMER_DATE_FORMAT:
      return action.payload;
  }
  
  return state;
};

export const infoMessage = (state = initialInfoMessage, action) => {
  switch (action.type) {
    case actionTypes.INFO_MESSAGE:
      return action.payload;
  }

  return state;
};

export const sideNavContent = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SIDE_NAV_CONTENT:
      return Object.assign({}, state, action.payload);
  }

  return state;
};

export const activityMenu = (state = [], action) => {
  switch (action.type) {
    case actionTypes.ACTIVITY_MENU:
      return [].concat(action.payload);
  }

  return state;
};

export const footerLinks = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FOOTERLINKS:
      return [].concat(action.payload);
  }

  return state;
};

export const cartLink = (state = '#', action) => {
  switch (action.type) {
    case actionTypes.CART_LINK:
      return action.payload;
  }

  return state;
};

export const catalogPoints = (state = '', action) => {
  switch (action.type) {
    case actionTypes.CATALOG_POINTS:
      return action.payload;
  }
  return state;
};

export const catalogSymbol = (state = '', action) => {
  switch (action.type) {
    case actionTypes.CATALOG_SYMBOL:
      return action.payload;
  }
  return state;
};

export const catalogLink = (state = '', action) => {
  switch (action.type) {
    case actionTypes.CATALOG_LINK:
      return action.payload;
  }

  return state;
};

export const banks = (state = [], action) => {
  switch (action.type) {
    case actionTypes.BANKS:
      return [].concat(action.payload);
  }

  return state;
};

export const banksCatalog = (state = [], action) => {
  switch (action.type) {
    case actionTypes.BANKS_CATALOG:
      return [].concat(action.payload);
  }

  return state;
};

export const awards = (state = [], action) => {
  switch (action.type) {
    case actionTypes.AWARDS:
      return [].concat(action.payload);
  }

  return state;
};

export const catalogs = (state = [], action) => {
  switch (action.type) {
    case actionTypes.CATALOGS:
      return [].concat(action.payload);
  }

  return state;
};

export const clientColors = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.CLIENT_COLORS:
      return Object.assign({}, state, action.payload);
  }

  return state;
};

export const greeting = (state = '', action) => {
  switch (action.type) {
    case actionTypes.GREETING:
      return action.payload;
  }

  return state;
};

export const basePath = (state = '', action) => {
  switch (action.type) {
    case actionTypes.BASE_PATH:
      return action.payload;
  }
  return state;
};

export const alertsCount = (state = 0, action) => {
  switch (action.type) {
    case actionTypes.ALERTS_COUNT:
      return action.payload;
  }
  return state;
};

export const genericAlerts = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GENERIC_ALERTS:
      return [].concat(action.payload);
  }
  return state;
};

export const receiveAlerts = (state = [], action) => {
  switch (action.type) {
    case actionTypes.RECEIVE_ALERTS:
      return [].concat(action.payload);
  }
  return state;
};

export const tabSelected = (state = 0, action) => {
  switch (action.type) {
    case actionTypes.SELECT_TAB:
      return action.payload;
  }
  return state;
};

export const bankNameSelected = (state = '', action) => {
  switch (action.type) {
    case actionTypes.SELECT_BANK:
      return action.payload;
  }
  return state;
};

export const activeBankId = (state = -1, action) => {
  switch (action.type) {
    case actionTypes.ACTIVE_BANK_ID:
      return action.payload;
  }

  return state;
};

export const personalInfoValues = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.PERSONAL_INFO_VALUES:
      return Object.assign({}, state, action.payload);
  }

  return state;
};

export const preferredLocale = (state = '', action) => {
  switch (action.type) {
    case actionTypes.PREFFERED_LANGUAGE_LOCALE:
      return action.payload;
  }
  
  return state;
};

export const hasGivenWidgetEnabled = (state = false, action) => {
  switch (action.type) {
    case actionTypes.HAS_WIDGET_ENABLED:
      return action.payload;
  }
  
  return state;
};

export const isDisplayMessageDialog = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_MESSAGE_DIALOG:
      return action.payload;
  }

  return state;
};

export const activeLanguage = (state = '', action) => {
  switch (action.type) {
    case actionTypes.ACTIVE_LANGUAGE:
      return action.payload;
  }

  return state;
};

export const isLoading = (state = true, action) => {
  switch (action.type) {
    case actionTypes.IS_LOADING:
      return action.payload;
  }

  return state;
};

export const displaySessionTimeOut = (state = false, action) => {
  switch (action.type) {
    case actionTypes.DISPLAY_SESSION_TIMEOUT:
      return action.payload;
  }

  return state;
};

export const logoutValue = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.LOGOUT:
      return Object.assign({}, state, action.payload);
  }

  return state;
};

export const isDisplaySideBarPanel = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_SIDEBAR_PANEL:
      return action.payload;
  }
  return state;
};

export const monthsWeeks = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.MONTHS_WEEKS:
      return Object.assign({}, state, action.payload);
  }

  return state;
};

export const avatarLink = (state = '', action) => {
  switch (action.type) {
    case actionTypes.AVATAR_LINK:
      return action.payload;
  }
  return state;
};

export const tasksCount = (state = 0, action) => {
  switch (action.type) {
    case actionTypes.TASKS_COUNT:
      return action.payload;
  }
  return state;
};

export const customerTitle = (state = '', action) => {
  switch (action.type) {
    case actionTypes.CUSTOMER_TITLE:
      return action.payload;
  }
  
  return state;
};

export const pageDropdownOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.PAGE_DROPDOWN_OPEN:
      return action.payload;
  }
  
  return state;
};

export const selectedDropDownValue = (state = '', action) => {
  switch (action.type) {
    case actionTypes.SELECTED_DROPDOWN_VALUE:
      return action.payload;
  }
  
  return state;
};

export const isDisplayCommonHeaderSideMenu = (state=true, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_COMMON_HEADER_SIDEMENU:
      return action.payload;
  }

  return state;
};

export const customerSTP = (state = '', action) => {
  switch (action.type) {
    case actionTypes.CUSTOMER_STP:
      return action.payload;
  }
  return state;
};

export const translationsGreatwork = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.TRANSLATIONS_GREATWORK:
      return Object.assign({}, state, action.payload);
  }
  return state;
};

export const redeemPrograms = (state = [], action) => {
  switch (action.type) {
    case actionTypes.REDEEM_PROGRAMS:
      return [].concat(action.payload);
  }

  return state;
};
